import styled from '@emotion/styled';
import { Helmet } from 'react-helmet';
import AppLayout from '../layout/AppLayout';
import { HeaderProjects as Header } from '../layout/Header';
import useModels from '../project/context/useModels';
import Loader from '../ui/Loader';
import ModelBlock from './blocks/model';
import useProjects from '../project/context/useProjects';

const Layout = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  min-height: calc(100vh - 64px);
  flex-grow: 1;
  gap: 16px;
  max-width: 1400px;
  width: 100%;
`;

const Top = styled.div`
  display: flex;
  flex-grow: 1;
  gap: 16px;
`;

const Bottom = styled.div`
  flex-grow: 2;
  display: flex;
  gap: 16px;
`;

const Left = styled.div`
  display: flex;
  flex-grow: 1;
  gap: 16px;
`;

const Dashboard = () => {
  const { models, loading: modelsLoading } = useModels();

  const radioModel = models?.find((model) => model.type === 'radio_impact');
  const otherRadioServices = models?.find(
    (model) => model.type === 'other_radio_services',
  );

  const radioProjectsState = useProjects({
    projectType: 'radio_impact',
    limit: 10,
  });
  const otherRadioProjectsState = useProjects({
    projectType: 'other_radio_services',
    limit: 5,
  });

  const allLoading =
    modelsLoading ||
    radioProjectsState.loading ||
    otherRadioProjectsState.loading;

  return (
    <AppLayout header={<Header />}>
      <Helmet>
        <title>{`Calculateur d'impact de l'activité d'une radio`}</title>
      </Helmet>

      {allLoading && <Loader fullPage />}

      {!allLoading && models && (
        <Layout>
          <Top>
            {radioModel && (
              <ModelBlock
                model={radioModel}
                projects={radioProjectsState.projects}
                count={radioProjectsState.count}
                remove={radioProjectsState.remove}
                duplicate={radioProjectsState.duplicate}
                sortOrder="date"
                limit={10}
              />
            )}
          </Top>
          <Bottom>
            {otherRadioServices && (
              <Left>
                <ModelBlock
                  model={otherRadioServices}
                  projects={otherRadioProjectsState.projects}
                  count={otherRadioProjectsState.count}
                  remove={otherRadioProjectsState.remove}
                  duplicate={otherRadioProjectsState.duplicate}
                  sortOrder="date"
                  limit={5}
                />
              </Left>
            )}
          </Bottom>
        </Layout>
      )}
    </AppLayout>
  );
};

export default Dashboard;
